import { createSelector } from 'reselect'

import { hasPermission } from 'Components/Permissions/utils'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'

import { status as allStatusOptions } from './options'

export const extendedFilters = state => state.search.extendedFilters
export const filters = state => state.search.filters

export const statusOptions = createSelector(
  [_userPermissions],
  userPermissions => {
    return allStatusOptions.filter(state => {
      switch (state.value) {
        case 'INSTOCK':
          return hasPermission('rug.status.inStock', userPermissions)

        case 'RESERVED':
          return hasPermission('rug.status.confirmed', userPermissions)

        case 'KNOTTING':
          return hasPermission('rug.status.knotting', userPermissions)

        case 'CONSIGNMENT':
          return hasPermission('rug.status.onConsignment', userPermissions)

        case 'SOLD':
          return hasPermission('rug.status.sold', userPermissions)

        case 'UNKNOWN':
          return hasPermission('rug.status.unknown', userPermissions)

        default:
          return false
      }
    })
  },
)
